import React from 'react';
import PropTypes from 'prop-types';
const ImageDetails = ({
  caption,
  credits,
  shouldDisplayCaption,
  shouldDisplayCredits
}) => /*#__PURE__*/React.createElement("div", {
  className: "image__details",
  "data-testid": "image-details"
}, shouldDisplayCaption && /*#__PURE__*/React.createElement("div", {
  className: "caption"
}, caption), shouldDisplayCredits && /*#__PURE__*/React.createElement("div", {
  className: "credits"
}, credits));
ImageDetails.propTypes = {
  caption: PropTypes.string,
  credits: PropTypes.string,
  shouldDisplayCaption: PropTypes.bool.isRequired,
  shouldDisplayCredits: PropTypes.bool.isRequired
};
ImageDetails.defaultProps = {
  caption: null,
  credits: null
};
export default ImageDetails;
//# sourceMappingURL=ImageDetails.js.map